import React from 'react'

import AvailabilityStore from '../stores/AvailabilityStore.js'
import AvailabilityActions from '../actions/AvailabilityActions.js'

import { translate } from 'react-i18next';

var PreOrderBlockSmallBusiness = React.createClass({


  getInitialState() {
    return {store: AvailabilityStore.getState()};
  },

  componentDidMount() {
    AvailabilityStore.listen(this.onChange);

  },

  componentWillUnmount() {
    AvailabilityStore.unlisten(this.onChange);
  },

  onChange(state) {
    this.setState({store: state});
  },

  stopCollapse() {
    AvailabilityActions.stopPreOrderCollapse();
  },

  showPreOrder() {
    AvailabilityActions.setPreOrderCollapseState('collapsing_min');
    setTimeout(function() {
      AvailabilityActions.setPreOrderCollapseState('collapsing_max');
      setTimeout(function() {
        AvailabilityActions.setPreOrderCollapseState('collapse_in');
      }, 350);
    }, 0); // .35s easing
  },

  hidePreOrder() {
    AvailabilityActions.setPreOrderCollapseState('collapsing_max');
    setTimeout(function() {
      AvailabilityActions.setPreOrderCollapseState('collapsing_min');
      setTimeout(function() {
        AvailabilityActions.setPreOrderCollapseState('collapse');
      }, 350);
    }, 0); // .35s easing
  },

  render() {
      const { t } = this.props;
      var store = this.state.store;

      let method = null;
      let collapse_class = '';
      let collapse_height = 0;

      let window_width = document.documentElement.clientWidth || window.innerWidth;
      let collapse_max = 1094;
      if(window_width > 992) {
        collapse_max = 585;
      } else if(window_width > 768) {
        collapse_max = 649;
      }

      switch(store.get('show_preorder')) {
        case 'collapse_in':
          collapse_class = 'collapse in';
          method = this.hidePreOrder;
          break;
        case 'collapse':
          collapse_class = 'collapse offcanvas';
          method = this.showPreOrder;
          break;
        case 'collapsing_max':
          collapse_class = 'collapsing';
          collapse_height = collapse_max;
          break;
        case 'collapsing_min':
          collapse_class = 'collapsing';
          collapse_height = 0;
          break;
      }

    return (
      <div>
        <p className="preorder_block__title">Pre-order Sonic Gigabit Fiber to be first in line!</p>

        <div role="tab" id="headingOne">

          <p className="preorder_block__link_container">

            <a onClick={method} className="preorder_block__link" data-parent="#accordion" aria-expanded="true" aria-controls="collapseOne">What is a pre-order? <span className="glyphicon glyphicon-question-sign" aria-hidden="true"></span></a>
          </p>
        </div>


        <div className={"container stepContainer preorder_block__collapse "+collapse_class} style={(collapse_height ? {height: collapse_height+'px'} : {})}>
      <div className="preorder_block__collapse__inner">
      <div className="row">
        <div className="col-xs-12">
          <p className="preorder_block__title2">What is a fiber pre-order?</p>
          <p className="preorder_block__description">By pre-ordering fiber, you are initiating the process for service delivery. The Sonic team will be monitoring fiber construction in your area, and will keep you up to date on the network build. You’re also placed on a wait list for installation, so you have priority installation over those who did not pre-order. </p>
        </div>

        <div className="col-xs-12">
          <div className="row">
            <div className="col-xs-12 col-sm-5 col-sm-offset-1 preorder_block__bullet_column">
              <p ><img src="https://www.sonic.com/sites/default/files/icon-construction-updates-v3.svg"/></p>
              <p className="preorder_block__description"><b>Access to Construction Progress</b><br />We will keep you up to date on every part of the process as Sonic builds a better internet directly to your front door! </p>
            </div>
            <div className="col-xs-12 col-sm-5 preorder_block__bullet_column">
              <p ><img src="https://www.sonic.com/sites/default/files/icon-priority-install-v2.svg" /></p>
              <p className="preorder_block__description"><b>Priority Installation</b><br />Sonic will contact you as soon as your fiber is ready for installation. We recommend that you hold off on canceling your current service until your Sonic fiber installation has been scheduled. </p>
            </div>
          </div>
        </div>

        <p className="preorder_block__title2">Interested in more information?</p>
        <p className="preorder_block__description">
          Give us a call at 1-855-757-6111 if you’d wish to discuss Sonic Small Business Fiber in more detail. Our Customer Care team is open Monday-Friday 8am-8:30pm, and weekends from 8am-6pm. You can also email us at: <a href="mailto:sales@sonic.com">sales@sonic.com</a>.
        </p>

        </div>
      </div>
      </div>
      </div>
    );
  }
});

export default  translate('common', { wait: true })(PreOrderBlockSmallBusiness);